import { useState, useEffect } from "react";

const useElementSize = (selector: string) => {
    const [size, setSize] = useState({ width: 0, height: 0 });

    useEffect(() => {
        const element = document.querySelector(selector);
        if (!(element instanceof HTMLElement)) return;

        const updateSize = () => {
            const { width, height } = element.getBoundingClientRect();
            setSize((prev) =>
                prev.width !== width || prev.height !== height
                    ? { width, height }
                    : prev
            );
        };

        updateSize(); // Obtener dimensiones iniciales

        // Observer para detectar cambios en el DOM
        const observer = new MutationObserver(updateSize);
        observer.observe(element, {
            attributes: true,
            childList: true,
            subtree: true,
        });

        return () => observer.disconnect();
    }, [selector]);

    return size;
};

export default useElementSize;
